export default "__VITE_ASSET__CHMxzhwx__"